export default {"src":"/_next/static/media/pin-user.0a320356.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};